import { render, staticRenderFns } from "./DonutChart.vue?vue&type=template&id=87767bc0&"
import script from "./DonutChart.vue?vue&type=script&lang=ts&"
export * from "./DonutChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports